module.exports = __webpack_public_path__ + "img/666.dd053267.png";